export enum StudyDesignType {
  Interventional = 'interventional',
  Observational = 'observational',
}
